import React from 'react';
import type { ParserRule } from '@/app_lib/htmlParser/inserter/rules/types';

// Add all default insertion rules here
export const insertionRules: ParserRule[] = [];

export function insertAtIndexRule({
  index,
  node,
  position,
}: {
  index: number;
  node: React.ReactNode;
  position: number;
}): boolean {
  if (!React.isValidElement(node)) {
    return false;
  }
  return index === position;
}

export function insertAtNodeRule({
  node,
  nodeType,
  position,
  nodeTracker,
}: {
  node: React.ReactNode;
  position: number;
  nodeType: string;
  nodeTracker: Record<string, number>;
}): boolean {
  if (!React.isValidElement(node) || node.type !== nodeType) {
    return false;
  }
  return nodeTracker[nodeType] === position;
}
